<template>
    <app-primary>
        <template #contentsHead>
            <sub-head-primary itemTitle="단지안내" tabActive="호수 배치도" bg="/images/sub/complex/visual.jpg">
                <template #title>단지안내</template>
            </sub-head-primary>
        </template>

        <page-section-primary titWrapClass="text-center" class="page-section--first page-section--last">
            <template #tit>호수 배치도</template>

            <div class="page-section__content">
                <v-row class="type-list">
                    <template v-for="(type, index) in types">
                        <v-col :key="index" cols="12" md="6">
                            <txt class="txt--lg mb-10px">
                                {{ type.name }}
                            </txt>
                            <v-divider />
                            <div class="pa-18px pa-md-24px">
                                <v-row class="row--xs">
                                    <template v-for="(child, index) in type.children">
                                        <v-col :key="index" cols="12" md="">
                                            <v-sheet rounded="pill" class="pa-16px" :class="`bg-${child.name}`">
                                                <txt class="text-center">
                                                    <strong class="text-uppercase">{{ child.name }} TYPE <br /></strong>
                                                    ({{ child.total }}세대 중 {{ child.target }}세대)
                                                </txt>
                                            </v-sheet>
                                        </v-col>
                                    </template>
                                </v-row>
                            </div>
                            <v-divider />
                        </v-col>
                    </template>
                </v-row>
                <!-- <sheet-tertiary>
                    <ul class="type-list">
                        <template v-for="(type, index) in types">
                            <li :key="index">
                                <v-row class="row--xs">
                                    <v-col cols="auto">
                                        <chip-quarternary class="w-md-140px justify-center white--text">
                                            {{ type.name }}
                                        </chip-quarternary>
                                    </v-col>
                                    <v-col cols="12" md="">
                                        <v-row class="row--xs">
                                            <template v-for="(child, index) in type.children">
                                                <v-col :key="index" cols="12" lg="6" xl="4">
                                                    <chip-quarternary :class="`bg-${child.name}`">
                                                        <span class="grey--text">
                                                            <span class="text-uppercase">{{ child.name }}</span> TYPE({{ child.area }}) {{ child.total }}세대 중 {{ child.target }}세대
                                                        </span>
                                                    </chip-quarternary>
                                                </v-col>
                                            </template>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </li>
                        </template>
                    </ul>
                </sheet-tertiary> -->
            </div>

            <div class="page-section__content">
                <div class="v-data-table v-data-table--line v-data-table--density-compact">
                    <div class="v-data-table__wrapper">
                        <table>
                            <thead>
                                <tr>
                                    <th-primary>층별</th-primary>
                                    <template v-for="(n, index) in 14">
                                        <th-primary :key="index">{{ index + 1 }}호</th-primary>
                                    </template>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-for="(item, index) in table">
                                    <tr :key="index">
                                        <th-secondary>{{ item.floor }}층</th-secondary>
                                        <template v-for="(room, index) in item.rooms">
                                            <td-primary :key="index" :class="`bg-${room.type}`">
                                                <template v-if="room.type">
                                                    <template v-if="room.type === 'null'">-</template>
                                                    <template v-else>{{ item.floor }}{{ room.number }}</template>
                                                </template>
                                            </td-primary>
                                        </template>
                                    </tr>
                                </template>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </page-section-primary>
    </app-primary>
</template>

<script>
import AppPrimary from "@/sets/parents/apps/app-primary.vue";
import SubHeadPrimary from "@/sets/parents/pages/sub-head-primary.vue";
import PageSectionPrimary from "@/sets/parents/pages/page-section-primary.vue";
import SheetTertiary from "@/components/publish/parents/sheets/sheet-tertiary.vue";
import ChipSecondary from "@/components/publish/parents/chips/chip-secondary.vue";
import ChipQuarternary from "@/components/publish/parents/chips/chip-quarternary.vue";
import ThPrimary from "@/components/publish/parents/tables/th-primary.vue";
import ThSecondary from "@/components/publish/parents/tables/th-secondary.vue";
import TdPrimary from "@/components/publish/parents/tables/td-primary.vue";
import Txt from "@/components/publish/styles/typography/txt.vue";

export default {
    props: {},
    components: {
        AppPrimary,
        SubHeadPrimary,
        PageSectionPrimary,
        SheetTertiary,
        ChipSecondary,
        ChipQuarternary,
        ThPrimary,
        ThSecondary,
        TdPrimary,
        Txt,
    },
    data: () => ({
        types: [
            {
                name: "청년형",
                children: [
                    { name: "21", total: "116", target: "94" },
                    { name: "26", total: "70", target: "57" },
                    //
                ],
            },
            {
                name: "신혼부부형",
                children: [
                    { name: "49", total: "45", target: "36" },
                    { name: "56", total: "22", target: "17" },
                    { name: "58", total: "46", target: "36" },
                    //
                ],
            },
        ],
        table: [
            {
                floor: "27",
                rooms: [
                    { number: "01", type: "21" },
                    { number: "02", type: "21" },
                    { number: "03", type: "21" },
                    { number: "04", type: "21" },
                    { number: "05", type: "21" },
                    { number: "06", type: "58" },
                    { number: "07", type: "49" },
                    { number: "08", type: "26" },
                    { number: "09", type: "26" },
                    { number: "10", type: "null" },
                    { number: "11", type: "49" },
                    { number: "12", type: "58" },
                    { number: "13" },
                    { number: "14" },
                    //
                ],
            },
            {
                floor: "26",
                rooms: [
                    { number: "01", type: "21" },
                    { number: "02", type: "21" },
                    { number: "03", type: "21" },
                    { number: "04", type: "21" },
                    { number: "05", type: "21" },
                    { number: "06", type: "56" },
                    { number: "07", type: "null" },
                    { number: "08", type: "49" },
                    { number: "09", type: "null" },
                    { number: "10", type: "26" },
                    { number: "11", type: "null" },
                    { number: "12", type: "null" },
                    { number: "13", type: "null" },
                    { number: "14" },
                    //
                ],
            },
            {
                floor: "25",
                rooms: [
                    { number: "01", type: "21" },
                    { number: "02", type: "21" },
                    { number: "03", type: "21" },
                    { number: "04", type: "21" },
                    { number: "05", type: "21" },
                    { number: "06", type: "56" },
                    { number: "07", type: "58" },
                    { number: "08", type: "49" },
                    { number: "09", type: "26" },
                    { number: "10", type: "26" },
                    { number: "11", type: "26" },
                    { number: "12", type: "null" },
                    { number: "13", type: "null" },
                    { number: "14" },
                    //
                ],
            },
            {
                floor: "24",
                rooms: [
                    { number: "01", type: "21" },
                    { number: "02", type: "21" },
                    { number: "03", type: "21" },
                    { number: "04", type: "null" },
                    { number: "05", type: "null" },
                    { number: "06", type: "56" },
                    { number: "07", type: "58" },
                    { number: "08", type: "49" },
                    { number: "09", type: "null" },
                    { number: "10", type: "26" },
                    { number: "11", type: "26" },
                    { number: "12", type: "49" },
                    { number: "13", type: "58" },
                    { number: "14" },
                    //
                ],
            },
            {
                floor: "23",
                rooms: [
                    { number: "01", type: "21" },
                    { number: "02", type: "21" },
                    { number: "03", type: "21" },
                    { number: "04", type: "21" },
                    { number: "05", type: "21" },
                    { number: "06", type: "56" },
                    { number: "07", type: "58" },
                    { number: "08", type: "49" },
                    { number: "09", type: "26" },
                    { number: "10", type: "26" },
                    { number: "11", type: "26" },
                    { number: "12", type: "49" },
                    { number: "13", type: "58" },
                    { number: "14" },
                    //
                ],
            },
            {
                floor: "22",
                rooms: [
                    { number: "01", type: "21" },
                    { number: "02", type: "21" },
                    { number: "03", type: "21" },
                    { number: "04", type: "21" },
                    { number: "05", type: "21" },
                    { number: "06", type: "56" },
                    { number: "07", type: "58" },
                    { number: "08", type: "49" },
                    { number: "09", type: "26" },
                    { number: "10", type: "null" },
                    { number: "11", type: "26" },
                    { number: "12", type: "49" },
                    { number: "13", type: "58" },
                    { number: "14" },
                    //
                ],
            },
            {
                floor: "21",
                rooms: [
                    { number: "01", type: "21" },
                    { number: "02", type: "21" },
                    { number: "03", type: "21" },
                    { number: "04", type: "21" },
                    { number: "05", type: "21" },
                    { number: "06", type: "56" },
                    { number: "07", type: "58" },
                    { number: "08", type: "49" },
                    { number: "09", type: "26" },
                    { number: "10", type: "26" },
                    { number: "11", type: "26" },
                    { number: "12", type: "49" },
                    { number: "13", type: "58" },
                    { number: "14" },
                    //
                ],
            },
            {
                floor: "20",
                rooms: [
                    { number: "01", type: "21" },
                    { number: "02", type: "null" },
                    { number: "03", type: "21" },
                    { number: "04", type: "21" },
                    { number: "05", type: "21" },
                    { number: "06", type: "56" },
                    { number: "07", type: "58" },
                    { number: "08", type: "49" },
                    { number: "09", type: "26" },
                    { number: "10", type: "26" },
                    { number: "11", type: "26" },
                    { number: "12", type: "49" },
                    { number: "13", type: "58" },
                    { number: "14" },
                    //
                ],
            },
            {
                floor: "19",
                rooms: [
                    { number: "01", type: "21" },
                    { number: "02", type: "21" },
                    { number: "03", type: "21" },
                    { number: "04", type: "21" },
                    { number: "05", type: "21" },
                    { number: "06", type: "56" },
                    { number: "07", type: "58" },
                    { number: "08", type: "49" },
                    { number: "09", type: "26" },
                    { number: "10", type: "26" },
                    { number: "11", type: "null" },
                    { number: "12", type: "49" },
                    { number: "13", type: "58" },
                    { number: "14" },
                    //
                ],
            },
            {
                floor: "18",
                rooms: [
                    { number: "01", type: "null" },
                    { number: "02", type: "21" },
                    { number: "03", type: "21" },
                    { number: "04", type: "null" },
                    { number: "05", type: "21" },
                    { number: "06", type: "null" },
                    { number: "07", type: "58" },
                    { number: "08", type: "49" },
                    { number: "09", type: "26" },
                    { number: "10", type: "26" },
                    { number: "11", type: "26" },
                    { number: "12", type: "null" },
                    { number: "13", type: "58" },
                    { number: "14" },
                    //
                ],
            },
            {
                floor: "17",
                rooms: [
                    { number: "01", type: "null" },
                    { number: "02", type: "21" },
                    { number: "03", type: "null" },
                    { number: "04", type: "21" },
                    { number: "05", type: "21" },
                    { number: "06", type: "56" },
                    { number: "07", type: "null" },
                    { number: "08", type: "49" },
                    { number: "09", type: "26" },
                    { number: "10", type: "26" },
                    { number: "11", type: "26" },
                    { number: "12", type: "49" },
                    { number: "13", type: "58" },
                    { number: "14" },
                    //
                ],
            },
            {
                floor: "16",
                rooms: [
                    { number: "01", type: "21" },
                    { number: "02", type: "null" },
                    { number: "03", type: "21" },
                    { number: "04", type: "21" },
                    { number: "05", type: "21" },
                    { number: "06", type: "56" },
                    { number: "07", type: "null" },
                    { number: "08", type: "49" },
                    { number: "09", type: "null" },
                    { number: "10", type: "26" },
                    { number: "11", type: "26" },
                    { number: "12", type: "49" },
                    { number: "13", type: "58" },
                    { number: "14" },
                    //
                ],
            },
            {
                floor: "15",
                rooms: [
                    { number: "01", type: "null" },
                    { number: "02", type: "21" },
                    { number: "03", type: "21" },
                    { number: "04", type: "21" },
                    { number: "05", type: "21" },
                    { number: "06", type: "56" },
                    { number: "07", type: "58" },
                    { number: "08", type: "49" },
                    { number: "09", type: "null" },
                    { number: "10", type: "26" },
                    { number: "11", type: "26" },
                    { number: "12", type: "49" },
                    { number: "13", type: "null" },
                    { number: "14" },
                    //
                ],
            },
            {
                floor: "14",
                rooms: [
                    { number: "01", type: "null" },
                    { number: "02", type: "21" },
                    { number: "03", type: "null" },
                    { number: "04", type: "21" },
                    { number: "05", type: "21" },
                    { number: "06", type: "56" },
                    { number: "07", type: "58" },
                    { number: "08", type: "null" },
                    { number: "09", type: "null" },
                    { number: "10", type: "26" },
                    { number: "11", type: "26" },
                    { number: "12", type: "null" },
                    { number: "13", type: "null" },
                    { number: "14" },
                    //
                ],
            },
            {
                floor: "13",
                rooms: [
                    { number: "01", type: "21" },
                    { number: "02", type: "21" },
                    { number: "03", type: "null" },
                    { number: "04", type: "21" },
                    { number: "05", type: "21" },
                    { number: "06", type: "null" },
                    { number: "07", type: "58" },
                    { number: "08", type: "49" },
                    { number: "09", type: "26" },
                    { number: "10", type: "26" },
                    { number: "11", type: "26" },
                    { number: "12", type: "49" },
                    { number: "13", type: "58" },
                    { number: "14" },
                    //
                ],
            },
            {
                floor: "12",
                rooms: [
                    { number: "01", type: "null" },
                    { number: "02", type: "21" },
                    { number: "03", type: "21" },
                    { number: "04", type: "21" },
                    { number: "05", type: "21" },
                    { number: "06", type: "null" },
                    { number: "07", type: "58" },
                    { number: "08", type: "49" },
                    { number: "09", type: "26" },
                    { number: "10", type: "26" },
                    { number: "11", type: "26" },
                    { number: "12", type: "null" },
                    { number: "13", type: "58" },
                    { number: "14" },
                    //
                ],
            },
            {
                floor: "11",
                rooms: [
                    { number: "01", type: "21" },
                    { number: "02", type: "null" },
                    { number: "03", type: "21" },
                    { number: "04", type: "null" },
                    { number: "05", type: "null" },
                    { number: "06", type: "56" },
                    { number: "07", type: "58" },
                    { number: "08", type: "49" },
                    { number: "09", type: "26" },
                    { number: "10", type: "26" },
                    { number: "11", type: "26" },
                    { number: "12", type: "49" },
                    { number: "13", type: "58" },
                    { number: "14" },
                    //
                ],
            },
            {
                floor: "10",
                rooms: [
                    { number: "01", type: "null" },
                    { number: "02", type: "21" },
                    { number: "03", type: "null" },
                    { number: "04", type: "21" },
                    { number: "05", type: "21" },
                    { number: "06", type: "null" },
                    { number: "07", type: "58" },
                    { number: "08", type: "null" },
                    { number: "09", type: "26" },
                    { number: "10", type: "26" },
                    { number: "11", type: "26" },
                    { number: "12", type: "null" },
                    { number: "13", type: "null" },
                    { number: "14" },
                    //
                ],
            },
            {
                floor: "9",
                rooms: [
                    { number: "01", type: "null" },
                    { number: "02", type: "21" },
                    { number: "03", type: "21" },
                    { number: "04", type: "21" },
                    { number: "05", type: "21" },
                    { number: "06", type: "56" },
                    { number: "07", type: "58" },
                    { number: "08", type: "null" },
                    { number: "09", type: "26" },
                    { number: "10", type: "26" },
                    { number: "11", type: "26" },
                    { number: "12", type: "49" },
                    { number: "13", type: "null" },
                    { number: "14" },
                    //
                ],
            },
            {
                floor: "8",
                rooms: [
                    { number: "01", type: "21" },
                    { number: "02", type: "21" },
                    { number: "03", type: "21" },
                    { number: "04", type: "21" },
                    { number: "05", type: "21" },
                    { number: "06", type: "56" },
                    { number: "07", type: "58" },
                    { number: "08", type: "49" },
                    { number: "09", type: "26" },
                    { number: "10", type: "26" },
                    { number: "11", type: "null" },
                    { number: "12", type: "49" },
                    { number: "13", type: "58" },
                    { number: "14" },
                    //
                ],
            },
            {
                floor: "7",
                rooms: [
                    { number: "01", type: "21" },
                    { number: "02", type: "21" },
                    { number: "03", type: "21" },
                    { number: "04", type: "21" },
                    { number: "05", type: "null" },
                    { number: "06", type: "56" },
                    { number: "07", type: "58" },
                    { number: "08", type: "49" },
                    { number: "09", type: "26" },
                    { number: "10", type: "26" },
                    { number: "11", type: "26" },
                    { number: "12", type: "49" },
                    { number: "13", type: "58" },
                    { number: "14" },
                    //
                ],
            },
            {
                floor: "6",
                rooms: [
                    { number: "01", type: "null" },
                    { number: "02", type: "21" },
                    { number: "03", type: "21" },
                    { number: "04", type: "21" },
                    { number: "05", type: "21" },
                    { number: "06", type: "null" },
                    { number: "07", type: "null" },
                    { number: "08", type: "49" },
                    { number: "09", type: "null" },
                    { number: "10", type: "null" },
                    { number: "11", type: "26" },
                    { number: "12", type: "49" },
                    { number: "13", type: "58" },
                    { number: "14" },
                    //
                ],
            },
            {
                floor: "5",
                rooms: [
                    { number: "01", type: "21" },
                    { number: "02", type: "21" },
                    { number: "03", type: "21" },
                    { number: "04", type: "21" },
                    { number: "05", type: "21" },
                    { number: "06", type: "56" },
                    { number: "07", type: "58" },
                    { number: "08", type: "49" },
                    { number: "09", type: "26" },
                    { number: "10", type: "26" },
                    { number: "11", type: "26" },
                    { number: "12", type: "null" },
                    { number: "13", type: "null" },
                    { number: "14", type: "58" },
                    //
                ],
            },
        ],
    }),
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped>
.type-list,
.v-data-table {
    .bg-21 {
        background-color: #d0eec7 !important;
    }
    .bg-26 {
        background-color: #b3d6ea !important;
    }
    .bg-49 {
        background-color: #ffca99 !important;
    }
    .bg-56 {
        background-color: #fdff9e !important;
    }
    .bg-58 {
        background-color: #ffecfa !important;
    }

    .bg-null {
        background-color: #b0b0b0 !important;
    }
}
.type-list {
    > li {
        margin-bottom: 18px;
        &:last-child {
            margin-bottom: 0;
        }
    }
}
.v-data-table {
    .empty {
        background-color: #fff !important;
    }
}
</style>
